import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import { useFileTokenContext } from "~/components/FilePreview/context/FileTokenContext.js";
import { prepareThumbnailUrl } from "~/utils/utils.jsx";
import { SelectAttachmentsItem } from "./SelectAttachmentsItem.js";
import { getUploadedFileByCode } from "../../store/selectors/selector.uploadedFiles.jsx";

export const UploadedFileAsListItemContainer = ({ id, onRemove, ...rest }) => {
  const { download_token, thumb_token } = useFileTokenContext();

  const file = useSelector((state) => getUploadedFileByCode(state, id));

  const type = useMemo(() => {
    if (file.isGoogleDriveFile()) {
      return "google";
    }

    if (file.isDropboxFile()) {
      return "dropbox";
    }

    if (file.isLocalFile()) {
      return "local";
    }

    if (file.isWarehouseFile()) {
      return "warehouse";
    }
  }, [file]);

  const thumbnailUrl = useMemo(
    () => prepareThumbnailUrl(file?.get("thumbnail_url"), 60, 60, "crop", thumb_token, download_token),
    [download_token, file, thumb_token]
  );

  if (!type) {
    return null;
  }

  return (
    <SelectAttachmentsItem
      id={id}
      name={file.name}
      onRemove={onRemove}
      type={type}
      thumbnailUrl={thumbnailUrl}
      {...rest}
    />
  );
};

UploadedFileAsListItemContainer.propTypes = {
  id: PropTypes.string,
  onRemove: PropTypes.func,
};
